function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, React.createElement("path", {
  d: "M6.105 10.018L1.783 5.696M6.105 1.374L1.783 5.696M1.78 5.696h15.468c.47 0 1.252.197 1.252.32v8.898c0 .148-.86.173-1.252.173H9.885"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-back-arrow-white.86c4b633.svg";
export { SvgComponent as ReactComponent };